import { EnvVariables } from './types';
import { LocalEnvVariables } from './local';
import { AcceptanceEnvVariables } from './acceptance';
import { ProdEnvVariables } from './prod';

export const getEnvVariables = (): EnvVariables => {
  if (window.location.hostname.includes('ipractice-test')) {
    return AcceptanceEnvVariables;
  }

  if (window.location.hostname.includes('ipractice')) {
    return ProdEnvVariables;
  }

  return LocalEnvVariables;
};
